import { useEffect, useRef } from "react";
import Address from "../../entities/Address";

interface GISAddress {
    aadress?: string;
    maakond?: string;
    omavalitsus?: string;
    liikluspind?: string;
    aadress_nr?: string;
    kort_nr?: string;
    sihtnumber?: string;
    adob_id?: number;
    asustusyksus?: string;
    paadress?: string;
    nimi?: string;
    lahiaadress?: string;
}

interface Props {
    value?: string;
    onAddressRequest: (address: Address) => void;
    onChange?: (value: string) => void;
    onClearClick?: () => void;
}

function mapGISAddressToAddress(GIS_address: GISAddress): Address {

    const address: Address = {
        Id: 0,
        Country: "Estonia",
        CountryShort: "EST",
        get AddressText() {
            return GIS_address?.paadress
                ? GIS_address?.paadress ?? ""
                : null;
        },
        County: GIS_address?.omavalitsus || null,
        State: GIS_address?.maakond || null,
        City: GIS_address?.asustusyksus || null,
        StreetName: GIS_address?.liikluspind || null,
        StreetNumber: GIS_address?.aadress_nr || null,
        Appartment: GIS_address?.kort_nr || null,
        Street: "",
        ZipCode: GIS_address?.sihtnumber || null,
        Adob_Id: GIS_address?.adob_id || null,
    };

    const streetNumberWithAppartment = [address.StreetNumber, address.Appartment]
        .filter(val => val !== null)
        .join("-");

    address.Street = [address.StreetName, streetNumberWithAppartment]
        .filter(val => val !== null && val.trim() !== "")
        .join(" ");

    if (!address.Street || address.Street.trim() === "") {
        address.Street = GIS_address?.lahiaadress ?? GIS_address?.nimi ?? "";
    }

    if (GIS_address?.asustusyksus?.endsWith(' küla') && !GIS_address?.omavalitsus?.endsWith(' linn')) {
        address.Street =  GIS_address?.lahiaadress ?? GIS_address?.nimi ?? "";
    }

    if ((GIS_address?.asustusyksus?.endsWith(' küla')) && GIS_address?.omavalitsus?.endsWith(' linn')) {
        mapAddress();
    }
    
    if ((GIS_address?.omavalitsus?.endsWith(' linn')) && address.City === null) {
        address.City = GIS_address?.omavalitsus || null;
    }

    function mapAddress() {
        const lahiaadress = GIS_address?.lahiaadress ?? "";

        address.Street = lahiaadress;
    }

    return address;
}

const GISAddressAutoComplete = ({ onChange = () => { }, onClearClick = () => { }, onAddressRequest, value }: Props) => {
    const inAadressRef = useRef<any>(null);
    const containerRef = useRef<any>(null);

    useEffect(() => {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src =
            "https://inaadress.maaamet.ee/inaadress/js/inaadress.min.js?d=20220510";
        document.head.appendChild(script);

        const initializeInAadress = () => {
            // to prevent multiple instances
            if (inAadressRef.current) {
                return;
            }
            inAadressRef.current = new (window as any).InAadress({
                container: "InAadressDiv",
                mode: 3,
                ihist: "1993",
                appartment: 2,
                lang: "et"
            });

            if (value) {
                inAadressRef.current.setAddress(value, true);
            }


            const popup = document.getElementById('InAadressDiv_popup');
            if (popup) {
                popup.remove();
            }

            if (inAadressRef.current.popup) {
                inAadressRef.current.popup = {
                    show: (content: any, header: any) => {
                        containerRef.current.innerHTML = content;
                        const appartmentContainer = containerRef.current.querySelector('.in-ads-appartment-conentent');
                        if (appartmentContainer) {
                            appartmentContainer.classList.remove('in-ads-appartment-conentent');
                            appartmentContainer.classList.add('appartment-container');
                        }

                        const btn = containerRef.current.querySelector('.in-ads-appart-select-btn');
                        if (btn) {
                            btn.classList.add('btn', 'btn-primary');
                        }
                        containerRef.current.classList.add('grow-down');
                        containerRef.current.classList.remove('hidden');

                    },
                    hide: () => {
                        containerRef.current.innerHTML = '';
                        containerRef.current.classList.add('hidden');
                    },
                    popup: containerRef.current
                };
            }
        };

        script.onload = initializeInAadress;

        return () => {
            if (inAadressRef.current && inAadressRef.current.destroy) {
                inAadressRef.current.destroy();
            }
            document.head.removeChild(script);
        };
    }, []);

    useEffect(() => {
        const observer = new MutationObserver(() => {
            const input = document.querySelector(".inads-input");

            if (input) {
                const handler = (e: Event) => onChange((e.target as HTMLInputElement).value);
                input.addEventListener("change", handler);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        const observer = new MutationObserver(() => {
            const input = document.querySelector(".inads-input-clear");

            if (input) {
                const handler = (e: Event) => onClearClick();
                input.addEventListener("click", handler);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        return () => observer.disconnect();
    }, []);

    const handleAddressRequest = (address: Address) => {
        if (!onAddressRequest) {
            return console.error(
                "Include onAddressRequest method to GISAddressAutoComplete component props to get address info!"
            );
        }
        onAddressRequest(address);
    };

    useEffect(() => {
        const handleAddressSelected = (e: CustomEvent) => {
            const info = e.detail;
            if (info && info.length > 0) {
                handleAddressRequest(mapGISAddressToAddress(info[0]));
            }
        };

        document.addEventListener(
            "addressSelected",
            handleAddressSelected as EventListener
        );

        return () => {
            document.removeEventListener(
                "addressSelected",
                handleAddressSelected as EventListener
            );
        };
    }, []);

    return <div className="gis-address">
        <div id="InAadressDiv">
        </div>
        <div ref={containerRef}
            className="in-ads-popup hidden">
        </div>
    </div>
};

export default GISAddressAutoComplete;
